export default {"src":"/_next/static/media/coupon.5015b440.svg","height":240,"width":320,"blurWidth":0,"blurHeight":0};